import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import Axios from "../axios";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";

const SliceAndDice = () => {
  const location = useLocation();

  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};

  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  const [totals, setTotals] = useState({
    totalGrossBookings: 0,
    totalNetBookings: 0,
  });
  //header for the CSv file
  const headers = [
    { label: "Hotel Name", key: "hotelName" },
    { label: "Gross bookings", key: "allBookingsCount" },
    { label: "Net bookings", key: "confirmedBookingsCount" },
    { label: "Cancelled bookings", key: "failedBookingsCount" },
    { label: "Gross Revenue", key: "totalRateBookings" },
    { label: "Net Revenue", key: "totalRateConfirmedBookings" },
    { label: "Cancelled Revenue", key: "totalRateFailedBookings" },
    { label: "Gross Room nights", key: "totalRoomCount" },
    { label: "Net Room nights", key: "totalConfirmedRoomCount" },
    { label: "Cancelled Room nights", key: "totalFailedRoomCount" },
    { label: "Avg daily Revenue", key: "DailyBooking" },
    { label: "% Sales based on revenue", key: "proportionRevenue" },
    { label: "% Sales based on bookings", key: "proportions" },
  ];

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(1, "", passedValue);
    } else {
      fetchAllTrip(1, "", "");
      handleDownloadProcess();
    }
  }, [passedValue]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      hotelName: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-top-hotel-sales", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-top-hotel-sales")
      .then((resp) => {
        const fetchedData = resp?.data?.data || [];

        // Calculate Totals
        const totalGrossBookings = fetchedData.reduce(
          (sum, item) => sum + (item.allBookingsCount || 0),
          0
        );
        const totalNetBookings = fetchedData.reduce(
          (sum, item) => sum + (item.confirmedBookingsCount || 0),
          0
        );
        const totalCancelledBookings = fetchedData.reduce(
          (sum, item) => sum + (item.failedBookingsCount || 0),
          0
        );

        const totalGrossRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateBookings || 0),
          0
        );
        const totalNetRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateConfirmedBookings || 0),
          0
        );
        const totalCancelRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateFailedBookings || 0),
          0
        );
        const totalGrossRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalRoomCount || 0),
          0
        );
        const totalNetRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalConfirmedRoomCount || 0),
          0
        );
        const totalCancelledRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalFailedRoomCount || 0),
          0
        );

        setTotals({
          totalGrossBookings,
          totalNetBookings,
          totalCancelledBookings,
          totalGrossRevenue,
          totalNetRevenue,
          totalCancelRevenue,
          totalGrossRoomNights,
          totalNetRoomNights,
          totalCancelledRoomNights,
        });

        // Add totals row to the CSV data
        const dataWithTotals = [
          ...fetchedData,
          {
            hotelName: "Total",
            allBookingsCount: totalGrossBookings,
            confirmedBookingsCount: totalNetBookings,
            failedBookingsCount: totalCancelledBookings,
            totalRateBookings: totalGrossRevenue,
            totalRateConfirmedBookings: totalNetRevenue,
            totalRateFailedBookings: totalCancelRevenue,
            totalRoomCount: totalGrossRoomNights,
            totalConfirmedRoomCount: totalNetRoomNights,
            totalFailedRoomCount: totalCancelledRoomNights, // Leave other fields blank or calculate if needed
          },
        ];

        setDownloadData(dataWithTotals);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Error fetching supplier data."
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(1, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"top20Hotel.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "hotelName",
      label: "Hotel Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "allBookingsCount",
      label: "Gross bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "confirmedBookingsCount",
      label: "Net bookings",

      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "failedBookingsCount",
      label: "Cancelled bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "totalRateBookings",
      label: "Gross Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(allTrip[dataIndex]?.totalRateBookings).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },

    {
      name: "totalRateConfirmedBookings",
      label: "Net Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateConfirmedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "totalRateFailedBookings",
      label: "Cancelled Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateFailedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },

    {
      name: "totalRoomCount",
      label: "Gross Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "totalConfirmedRoomCount",
      label: "Net Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "totalFailedRoomCount",
      label: "Cancelled Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "DailyBooking",
      label: "Avg daily Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>{parseFloat(allTrip[dataIndex]?.DailyBooking).toFixed(2)}</p>
            </>
          );
        },
      },
    },
    {
      name: "proportionRevenue",
      label: "% Sales based on revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(allTrip[dataIndex]?.proportionRevenue).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "proportions",
      label: "% Sales based on bookings",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>{parseFloat(allTrip[dataIndex]?.proportions).toFixed(2)}</p>
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      <MUIDataTable
        title={"Top 20 Hotel List"}
        data={allTrip}
        columns={columns}
        options={options}
      />
    </>
  );
};
export default SliceAndDice;
